module.exports = __webpack_public_path__ + "static/japan02-f0043d1e9f48cf8d0826ac1a97a94153.jpg";